import { useState } from "react";
import * as React from "react";
import { InvestmentSectorAllocationModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentSectorAllocationModel";
import { ColumnChart } from "../../../../../../../Shared/Chart/ColumnChart";
import AutoHeight from "../../../../../../../Shared/Components/AutoHeight";
import { SectorAllocationTable } from "./SectorAllocationTable";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";

interface ISectorAllocationWidgetProps {
    SectorAllocationData: InvestmentSectorAllocationModel;
    isHeadAccount: boolean;
}

export const SectorAllocationWidget: React.FunctionComponent<ISectorAllocationWidgetProps> = (props) => {
    enum Views {
        Table,
        Chart,
    }
    const [view, setView] = useState<Views>(Views.Chart);
    const { addEvent } = new AdviserSiteTagManager();
    return (
        <>
            <div className="row narrow-gutter pb-8">
                <div className="col-fluid col-bottom">
                    <h2 className="h3 mb-0">Sector allocation</h2>
                </div>
                <div className="col-auto">
                    <button
                        onClick={() => {
                            addEvent({
                                event: "insightstab_interaction",
                                eventParameters: {
                                    eventAction: "interactions",
                                    eventCategory: eventCategoryForGTM.insightsTab,
                                    eventLabel: `sector allocation - chart`,
                                },
                            });
                            setView(Views.Chart);
                        }}
                        aria-pressed={view == Views.Chart}
                        className="column-chart-view-button"
                        title="Column chart view"
                    >
                        <span className="sr-only">Set column chart view</span>
                        <span className="icon" aria-hidden={true}></span>
                    </button>
                </div>
                <div className="col-auto">
                    <button
                        onClick={() => {
                            addEvent({
                                event: "insightstab_interaction",
                                eventParameters: {
                                    eventAction: "interactions",
                                    eventCategory: eventCategoryForGTM.insightsTab,
                                    eventLabel: `sector allocation - table`,
                                },
                            });
                            setView(Views.Table);
                        }}
                        aria-pressed={view == Views.Table}
                        className="table-view-button"
                        title="Data table view"
                    >
                        <span className="sr-only">Set table view</span>
                        <span className="icon" aria-hidden={true}></span>
                    </button>
                </div>
            </div>
            <div className={view == Views.Chart ? "panel " : "panel pt-0 pb-0"}>
                <AutoHeight>
                    {view == Views.Chart ? (
                        <ColumnChart
                            data={props.SectorAllocationData.AssetSectorAllocations}
                            height={140}
                            maxBarWidth={100}
                        />
                    ) : (
                        <SectorAllocationTable isHeadAccount={props.isHeadAccount} data={props.SectorAllocationData} />
                    )}
                </AutoHeight>
            </div>
        </>
    );
};
